<template>
    <div v-if="table">
        <!-- Render a custom view -->
        <div v-if="document && view && view.layout && view.layout.rows">
            <div v-for="(row, index) in view.layout.rows">
                <row-renderer :layout="view.layout" :row="row" :index="index" :key="index + view.id + 'row'"
                              :document="document" :table="table" :view="view"></row-renderer>
            </div>
        </div>

        <!-- Render a static default view -->
        <static-form-view v-else :table_id="table.id" :document_id="documentId"></static-form-view>
    </div>
</template>

<script>

    import StaticFormView from "./StaticFormView.vue";
    import TableUtil from "../../utils/TableUtil";
    import ModelService from "../../services/ModelService";

    export default {
        name: 'FormContainer',
        components: {StaticFormView},
        // props: {
        //     view: Object,
        //     // table: Object,
        //     document: Object,
        //     recordId: String
        // },
        data() {
            return {
                model: webase.model,
                tableId: null,
                documentId: null,
                table: null,
                view: null,
                document: null,
                service: new ModelService()
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            this.tableId = this.$route.params.table_id

            console.log('FormContainer, table id: ' + this.tableId)

            if(this.$route.params.document_id) {
                this.documentId = this.$route.params.document_id
            }

            this.table = webase.utils.array.get(this.model.app.tables, this.tableId)

            if(webase.utils.table.hasFormView(this.table)) {
                this.view = webase.utils.table.getFormView(this.table)
                this.initDocument()
            }


            // let viewId = this.$route.params.view_id
            // this.recordId = this.$route.params.record_id
            //
            // this.viewService.get(viewId).then((response) => {
            //     this.view = response
            //     let app = response.app
            //     console.log('Details initi app')
            //     webase.utils.app.initAppProperties(app)
            //     this.model.app = app
            //     this.table = webase.utils.array.get(this.model.app.tables, this.view.model_id)
            //
            //     this.loadData()
            // }).catch((message) => {
            //     console.log('error loading view')
            //     console.log(message)
            // })
        },
        methods: {
            initDocument(){
                if( this.documentId ) {
                    this.loadData()
                }
                else {
                    let tableUtil = new TableUtil()
                    this.document = tableUtil.createRecord(this.table)

                    if(this.parentDocumentId) {
                        this.document['parent_id'] = this.parentDocumentId
                    }
                }
            },
            loadData() {
                this.service.getDocument(this.table, this.documentId).then((response) => {
                    this.document = response
                }).catch((message) => {
                    console.log('error loading table')
                    console.log(message)
                })
            },
            // isEditable(field) {
            //     return new FieldUtil(field).editable()
            // }
        }
    }
</script>

<style>

</style>
